
/**
 * Quick View Functionality
 */

function openQuickView(button) {
    const handle = button.dataset.productHandle;
    if (!handle) return;

    const modal = document.getElementById('QuickViewModal');
    const content = document.getElementById('QuickViewContent');
    const loading = document.getElementById('QuickViewLoading');
    const modalContent = document.getElementById('QuickViewModalContent');

    // Show modal
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden'; // Prevent body scroll

    // Reset state
    content.innerHTML = '';
    content.classList.add('hidden');
    loading.classList.remove('hidden');

    // Animate in
    requestAnimationFrame(() => {
        modal.classList.remove('opacity-0');
        modalContent.classList.remove('scale-95');
        modalContent.classList.add('scale-100');
    });

    // Fetch product data
    fetch(`/products/${handle}?section_id=quick-view`)
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const quickViewContent = html.querySelector('.quick-view__content');

            if (quickViewContent) {
                content.innerHTML = quickViewContent.outerHTML;
                loading.classList.add('hidden');
                content.classList.remove('hidden');

                // Initialize product form manually
                const form = content.querySelector('form[action*="/cart/add"]');
                if (form) {
                    form.addEventListener('submit', (e) => {
                        e.preventDefault();
                        const submitButton = form.querySelector('[type="submit"]');
                        if (submitButton) submitButton.classList.add('loading');

                        const formData = new FormData(form);

                        // Ensure ID is present
                        if (!formData.get('id')) {
                            const idInput = form.querySelector('[name="id"]');
                            if (idInput) formData.append('id', idInput.value);
                        }

                        const config = {
                            method: 'POST',
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept': 'application/javascript'
                            },
                            body: formData
                        };

                        fetch(window.Shopify.routes.root + 'cart/add.js', config)
                            .then(response => response.json())
                            .then(response => {
                                if (response.status) {
                                    // Error
                                    console.error(response.description);
                                    return;
                                }
                                // Success - close modal and update cart
                                closeQuickView();

                                // Fetch updated cart drawer and cart icon
                                // Ensure drawer updates when cart was previously empty
                                fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)
                                    .then(response => response.json())
                                    .then(sections => {
                                        const cartDrawer = document.querySelector('cart-drawer');

                                        if (cartDrawer && sections['cart-drawer']) {
                                            const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');

                                            // Remove is-empty class if cart now has items
                                            cartDrawer.classList.remove('is-empty');
                                            const drawerInner = cartDrawer.querySelector('.drawer__inner');
                                            if (drawerInner) {
                                                drawerInner.classList.remove('is-empty');
                                            }

                                            // Update cart drawer content - use full #CartDrawer replacement
                                            const cartDrawerElement = cartDrawer.querySelector('#CartDrawer');
                                            const sourceCartDrawer = html.querySelector('#CartDrawer');
                                            if (cartDrawerElement && sourceCartDrawer) {
                                                cartDrawerElement.innerHTML = sourceCartDrawer.innerHTML;
                                            }

                                            // Update cart icon bubble
                                            const cartIconBubble = document.querySelector('#cart-icon-bubble');
                                            if (cartIconBubble && sections['cart-icon-bubble']) {
                                                const iconHtml = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                                                const sourceElement = iconHtml.querySelector('#cart-icon-bubble');
                                                if (sourceElement) {
                                                    cartIconBubble.innerHTML = sourceElement.innerHTML;
                                                } else {
                                                    // Fallback if the ID isn't on the root of the returned HTML
                                                    cartIconBubble.innerHTML = sections['cart-icon-bubble'];
                                                }
                                            }

                                            // Open drawer after content is updated
                                            setTimeout(() => {
                                                cartDrawer.open();
                                            }, 100);
                                        }

                                        // Also dispatch event for other listeners
                                        document.dispatchEvent(new CustomEvent('cart:refresh', {
                                            bubbles: true,
                                            detail: {
                                                cart: sections
                                            }
                                        }));
                                    })
                                    .catch((e) => {
                                        console.error('Error updating cart drawer:', e);
                                    });
                            })
                            .catch((e) => {
                                console.error(e);
                            })
                            .finally(() => {
                                if (submitButton) submitButton.classList.remove('loading');
                            });
                    });
                }
            }
        })
        .catch((error) => {
            console.error('Error fetching quick view:', error);
            content.innerHTML = '<p class="text-center text-red-600">Failed to load product details.</p>';
            loading.classList.add('hidden');
            content.classList.remove('hidden');
        });
}

function closeQuickView() {
    const modal = document.getElementById('QuickViewModal');
    const modalContent = document.getElementById('QuickViewModalContent');

    // Animate out
    modal.classList.add('opacity-0');
    modalContent.classList.remove('scale-100');
    modalContent.classList.add('scale-95');

    setTimeout(() => {
        modal.classList.add('hidden');
        document.body.style.overflow = ''; // Restore body scroll
        document.getElementById('QuickViewContent').innerHTML = ''; // Clean up
    }, 300);
}

// Close on backdrop click
document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('QuickViewModal');
    if (modal) {
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                closeQuickView();
            }
        });
    }
});

// Close on Escape key
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const modal = document.getElementById('QuickViewModal');
        if (modal && !modal.classList.contains('hidden')) {
            closeQuickView();
        }
    }
});
